import React, { useState } from 'react';
import { Plus, UserPlus } from 'lucide-react';
import { mockApprovalFlows, mockApprovers } from '../data/mockData';

// 规则配置视图：审批流 + 审批人设置
const SettingsView = () => {
  const [settingsTab, setSettingsTab] = useState('flow'); // 'flow' | 'approver'
  const [flows] = useState(mockApprovalFlows);
  const [approvers] = useState(mockApprovers);

  return (
    <div className="space-y-6">
      <div className="flex gap-6 border-b border-slate-200">
        <button
          onClick={() => setSettingsTab('flow')}
          className={`pb-3 text-sm font-medium relative ${settingsTab === 'flow' ? 'text-blue-600' : 'text-slate-500 hover:text-slate-700'}`}
        >
          审批流配置
          {settingsTab === 'flow' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 rounded-t-full" />}
        </button>
        <button
          onClick={() => setSettingsTab('approver')}
          className={`pb-3 text-sm font-medium relative ${settingsTab === 'approver' ? 'text-blue-600' : 'text-slate-500 hover:text-slate-700'}`}
        >
          审批人设置
          {settingsTab === 'approver' && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600 rounded-t-full" />}
        </button>
      </div>

      {settingsTab === 'flow' && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
            <p className="text-sm text-slate-600">配置各类业务对应的审批流程与节点顺序，新建单据将按此流程流转。</p>
            <button className="flex items-center gap-1.5 text-xs bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 shadow-sm">
              <Plus size={14} /> 新增审批流
            </button>
          </div>
          <table className="w-full text-left text-sm">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-100">
              <tr>
                <th className="p-4 font-medium">审批流名称</th>
                <th className="p-4 font-medium">适用类型</th>
                <th className="p-4 font-medium">审批节点（顺序）</th>
                <th className="p-4 font-medium">状态</th>
                <th className="p-4 text-right font-medium">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {flows.map((f) => (
                <tr key={f.id} className="hover:bg-slate-50">
                  <td className="p-4 font-medium text-slate-800">{f.name}</td>
                  <td className="p-4">
                    <span className="px-2 py-1 rounded text-xs border bg-slate-50 text-slate-700 border-slate-200">{f.typeLabel}</span>
                  </td>
                  <td className="p-4">
                    <div className="flex flex-wrap gap-1.5">
                      {f.steps.map((step, i) => (
                        <span key={step} className="inline-flex items-center gap-1 bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs">
                          {i + 1}. {step}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded text-xs ${f.enabled ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                      {f.enabled ? '启用' : '停用'}
                    </span>
                  </td>
                  <td className="p-4 text-right">
                    <button className="text-blue-600 hover:underline text-xs mr-3">编辑</button>
                    <button className="text-slate-500 hover:underline text-xs">复制</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {settingsTab === 'approver' && (
        <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="p-4 border-b border-slate-100 flex justify-between items-center bg-slate-50/50">
            <p className="text-sm text-slate-600">为每个审批节点指定默认审批人，审批任务将推送至对应人员。</p>
            <button className="flex items-center gap-1.5 text-xs bg-blue-600 text-white px-3 py-2 rounded-lg hover:bg-blue-700 shadow-sm">
              <UserPlus size={14} /> 指定审批人
            </button>
          </div>
          <table className="w-full text-left text-sm">
            <thead className="bg-slate-50 text-slate-500 border-b border-slate-100">
              <tr>
                <th className="p-4 font-medium">审批节点</th>
                <th className="p-4 font-medium">指定审批人</th>
                <th className="p-4 font-medium">岗位/角色</th>
                <th className="p-4 font-medium">备注</th>
                <th className="p-4 text-right font-medium">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {approvers.map((a) => (
                <tr key={a.id} className="hover:bg-slate-50">
                  <td className="p-4 font-medium text-slate-800">{a.stepLabel}</td>
                  <td className="p-4 text-slate-700">{a.assignee}</td>
                  <td className="p-4 text-slate-600 text-xs">{a.assigneeRole}</td>
                  <td className="p-4 text-slate-500 text-xs">{a.remark || '-'}</td>
                  <td className="p-4 text-right">
                    <button className="text-blue-600 hover:underline text-xs">更换</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SettingsView;
